module.exports = __webpack_public_path__ + "img/06.16633d66.jpg";